import { ProgressBar } from "primereact/progressbar";

export function ProgressBarWithLabel({
  current = 0,
  total = 100,
  unit = "",
  color = "",
  ptClassName = "h-4",
}) {
  const percentage = (current / total) * 100;

  return (
    <div style={{ position: "relative" }}>
      <ProgressBar
        className={ptClassName}
        value={percentage}
        showValue={false} // Disable built-in label completely
        color={color}
      />
      {/* Always render our own label */}
      <div
        className="text-center text-xs font-semibold w-full"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
          color: percentage > 50 ? "white" : "#333",
        }}
      >
        {current}/{total} {unit}
      </div>
    </div>
  );
}
export default ProgressBarWithLabel;
